export default "__VITE_ASSET__f09975d1__"